import { clone } from './view_case_details_core_helpers';

export const VIEW_CASE_DETAILS_STATE = {
      active_tab: 'reasoning',
      people_panel_collapsed: true,
      info_banner: 'The verdict view structure (header -> outcome band -> next action -> reasoning trail -> risk panel) is identical for every case type. Only the data inside changes per tenant. Shown below: an insurance claim example, deliberately not legal - the same layout serves legal matters, service requests, oversight investigations and HR grievances.',
      case_header: {
        meta: 'C-2026-0142 - Claim opened 04 May 2026 - Insurance - Motor',
        title: '',
        subtitle: '',
        status_badge: ''
      },
      summary_rows: [
        { label: 'Domain', value: '', badge_class: 'bg-primary-subtle text-primary-emphasis', is_badge: true },
        { label: 'Status', value: 'In review', dot_class: 'bg-success', is_status: true },
        { label: 'Owner', value: 'Unassigned' },
        { label: 'Coordinator', value: 'Unassigned' },
        { label: 'Claim type', value: '' },
        { label: 'Excess', value: 'R 5,500' },
        { label: 'Hours logged', value: '2.8h' },
        { label: 'Decision due', value: '' }
      ],
      backend_fact_columns: [],
      backend_application_forms: [],
      backend_domain_label: '',
      backend_submitter_name: '',
      backend_what_happened_answer: '',
      backend_case_context_parts: [],
      backend_case_opened_at: '',
      editing_fact_section_key: '',
      editing_fact_answers: [],
      saving_fact_section_key: '',
      fact_edit_error: '',
      fact_validation_errors: [],
      fact_edit_success: '',
      fact_edit_success_timeout_id: null,
      submitting_case_form: false,
      case_form_submission_error: '',
      case_form_submission_success: '',
      verification_checks: [],
      loading_verification_checks: false,
      running_verification_keys: [],
      verification_error: '',
      resolved_entity_profile_id: null,
      resolved_entity_type_id: null,
      loading_case_facts: false,
      case_facts_error: '',
      statement_quote: 'I came round the bend a bit fast in the rain, lost the back end and clipped the barrier. No-one else involved, no injuries. Towed straight to Speedy Auto on the Monday.',
      signal_pills: [
        'Prior claim PM-841220 (Sep 2025) - same workshop',
        'Prior claim PM-867013 (Jan 2026) - same workshop',
        'Workshop on 7 flagged claims this quarter',
        'Policy active 3y - no lapses',
        'Premium paid on time'
      ],
      signal_timeline: [
        { meta: 'Sat 9 May', title: 'Incident occurs' },
        { meta: 'Mon 11 May', title: 'Towed to workshop' },
        { meta: '10 May 10:30', title: 'Claim filed' },
        { meta: '13 May 14:42', title: 'Risk re-scored', alert: true },
        { meta: '14 May 08:14', title: 'SLA breach', alert: true },
        { meta: '14 May - Today', title: 'Decision pending' }
      ],
      outcome_band: {
        marker: 1
      },
      action_card: {
        title: 'Request on-site inspection at Speedy Auto Edenvale before payout authorisation.',
        owner: 'S. Naidoo',
        by: 'Today, 16:00',
        confidence: '82% (history match)',
        exposure: 'R 142,800 -> ~R 32k post-assessment',
        body: 'The workshop appears as third-party on 7 prior flagged claims this quarter. The claimant\'s two previous claims (PM-841220, PM-867013) used the same workshop. System recommends inspection before payment is released.'
      },
      risk_panel: null,
      loading_risk_panel: false,
      risk_panel_message: 'Loading risk score from backend...',
      sla_runtimes: [],
      loading_sla_runtimes: false,
      sla_runtimes_error: '',
      people: [
        { initials: 'SN', class: 'bg-success', name: 'Sundeep Naidoo', role: 'Owner - Senior Adjuster' },
        { initials: 'NM', class: 'case-details-avatar-amber', name: 'Nthabiseng Mokwena', role: 'Intake - Claims call centre' },
        { initials: 'PM', class: 'bg-purple text-white', name: 'Pulane Maboe', role: 'Coordinator - Claims Ops Gauteng' }
      ],
      show_decision_modal: false,
      action_decision_modal: '',
      action_decision_reason: '',
      action_completed: false,
      selected_decision_status_id: '',
      decision_reason: '',
      decision_application_form_id: null,
      workflow_statuses: [],
      workflow_transition_rules: [],
      loading_decision_workflow: false,
      submitting_decision: false,
      decision_error: '',
      backend_available_transitions: [],
      show_reassign_modal: false,
      reassign_search: '',
      selected_reassign_users: [],
      reassign_note: '',
      reassign_panel_members: [],
      backend_assigned_users: [],
      loading_reassign_users: false,
      submitting_reassign: false,
      reassign_error: '',
      reassign_success: '',
      tabs: [
        { key: 'reasoning', label: 'Reasoning trail' },
        { key: 'documents', label: 'Documents (5)' },
        { key: 'time', label: 'Time (2.8h)' },
        { key: 'notes', label: 'Notes' },
        { key: 'audit', label: 'Audit log' }
      ],
      backend_reasoning_items: [],
      reasoning_items: [],
      documents: [
        { name: 'Repair quote - Speedy Auto', meta: 'PDF - 14 May 11:08 - R 142,800' },
        { name: 'Damage photos (4)', meta: 'JPG - 14 May 11:08 - claimant upload' },
        { name: 'Policy schedule', meta: 'PDF - verified against PM-883441' },
        { name: 'SAPS reference capture', meta: 'PNG - 14 May 11:08' },
        { name: 'Driver statement', meta: 'Portal text submission - 10 May' }
      ],
      backend_documents: [],
      loading_documents: false,
      documents_error: '',
      documents_success: '',
      uploading_document: false,
      upload_progress: 0,
      selected_document: null,
      document_review_mode: '',
      document_review_comment: '',
      submitting_document_review: false,
      backend_time_entries: [],
      loading_time_entries: false,
      time_entries_error: '',
      time_entries_success: '',
      submitting_time_entry: false,
      new_time_activity: '',
      new_time_hours: '0.5',
      new_time_billable: false,
      new_time_evidence_files: [],
      notes: [],
      backend_notes: [],
      loading_notes: false,
      notes_error: '',
      notes_success: '',
      submitting_note: false,
      new_note_body: '',
      selected_note_mention_key: '',
      note_mention_menu_open: false,
      note_mention_query: '',
      note_mention_start_index: -1,
      replying_note_id: '',
      note_reply_body: '',
      submitting_note_reply: false,
      backend_audit_rows: [],
      loading_audit_logs: false,
      audit_logs_error: ''
};

export function create_view_case_details_state() {
  return clone(VIEW_CASE_DETAILS_STATE);
}
